import { render, staticRenderFns } from "./TaskModal.vue?vue&type=template&id=2d9e6c93"
import script from "./TaskModal.vue?vue&type=script&lang=js"
export * from "./TaskModal.vue?vue&type=script&lang=js"
import style0 from "./TaskModal.vue?vue&type=style&index=0&id=2d9e6c93&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports